import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CloudBackup } from "lucide-react";
import { UsuarioContext } from "../../providers/userContext";
import { useVisitQueue } from "../../providers/visitQueueContext";


const VisitQueueNav = ({ variant = "full" }) => {
  const { t } = useTranslation("nav");
  const user = useContext(UsuarioContext);
  const { totalCount, errorCount, sentCount } = useVisitQueue();

  const esTecnico = user?.rol === "TECH" || user?.rol === "TECH_COOR";
  if (!esTecnico || (totalCount === 0 && sentCount === 0)) return null;
  const mostrarBadge = totalCount > 0;

  const label = t("clients.visitQueue", { defaultValue: "Cola de visitas" });
  const badgeTextColor = errorCount > 0 ? "#d32f2f" : "#92004D";

  if (variant === "icon") {
    return (
      <li title={label} style={{ opacity: 1 }}>
        <NavLink
          activeclassname="active"
          to="/cola-visitas"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "inherit",
            textDecoration: "none",
          }}
        >
          <span style={{ position: "relative", display: "inline-flex", lineHeight: 0 }}>
            <CloudBackup stroke-width="1.5" alt={label} />
            {mostrarBadge && (
              <span
                style={{
                  position: "absolute",
                  top: -8,
                  left: -8,
                  minWidth: 17,
                  height: 17,
                  padding: "0 4px",
                  borderRadius: 9,
                  fontSize: 10,
                  fontWeight: 700,
                  lineHeight: "17px",
                  textAlign: "center",
                  color: badgeTextColor,
                  backgroundColor: "#fff",
                  boxShadow: "0 0 2px rgba(0,0,0,0.4)",
                }}
              >
                {totalCount}
              </span>
            )}
          </span>
        </NavLink>
      </li>
    );
  }

  return (
    <li>
      <NavLink activeclassname="active" to="/cola-visitas" style={{ display: "block" }}>
        <div
          className="menuBtn"
          style={{ position: "relative", display: "flex", alignItems: "center" }}
        >
          <CloudBackup stroke-width="1.5" alt={label} />
          {label}
          {mostrarBadge && (
            <span
              style={{
                marginLeft: 8,
                minWidth: 22,
                height: 20,
                padding: "0 6px",
                borderRadius: 10,
                fontSize: 12,
                fontWeight: 700,
                lineHeight: "20px",
                textAlign: "center",
                color: badgeTextColor,
                backgroundColor: "#fff",
                display: "inline-block",
                boxShadow: "0 0 2px rgba(0,0,0,0.3)",
              }}
            >
              {totalCount}
            </span>
          )}
        </div>
      </NavLink>
    </li>
  );
};

export default VisitQueueNav;